import { XhrFactory } from '@angular/common';
import { HttpClient, HttpXhrBackend } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export class BrowserXhr implements XhrFactory {
  build(): any {
    return new XMLHttpRequest();
  }
}

export const XHR_HTTP_CLIENT = new InjectionToken<HttpClient>(
  'XHR_HTTP_CLIENT',
  {
    providedIn: 'root',
    factory: () => {
      return new HttpClient(new HttpXhrBackend(new BrowserXhr()));
    },
  }
);
